import { baseApi } from "../api/baseApi";
import { updateAzureTokens } from "../slices/authSlice";
import {
  RefreshTokenRequest,
  TokenResponse,
  ExternalUserAuthResponse,
  SsoUrlResponse,
} from "../types/auth.types";


export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSsoUrl: builder.query<SsoUrlResponse, void>({
      query: () => {
        const url = "/v1/Login/GetSsoUrlB2b";
        return {
          url,
        };
      },
    }),
    getAuthInfo: builder.query<ExternalUserAuthResponse, void>({
      query: () => {
        const url = "/v2/crm/authinfo";
        return {
          url,
        };
      },
    }),
    refreshAzureToken: builder.mutation<TokenResponse, RefreshTokenRequest>({
      query: (credentials) => ({
        url: "/v1/Login/RefreshAzureToken",
        method: "POST",
        body: credentials,
      }),
      // Uppdatera Redux store automatiskt efter en framgångsrik förnyelse
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            updateAzureTokens({
              azure_token: data.access_token,
              azure_refresh_token: data.refresh_token,
              azure_token_expires: Date.now() + data.expires_in * 1000,
            })
          );
        } catch (err) {
          console.error("Failed to refresh token:", err);
        }
      },
    }),
  }),
});

export const { useGetSsoUrlQuery, useLazyGetSsoUrlQuery, useRefreshAzureTokenMutation , useGetAuthInfoQuery} = authApi;
